import { LocalStorageKeysEnum } from '../constants/constants';

export const getToken = (): string | null =>
  localStorage.getItem(LocalStorageKeysEnum.jwtToken);
